var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88,10.68a1.07,1.07,0,0,0,2.13,0h0v0h0a1.07,1.07,0,0,0-2.13,0h0v0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88,17.61a1.07,1.07,0,0,0,2.13,0h0a1.07,1.07,0,0,0-2.13,0h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88,14.15a1.07,1.07,0,0,0,2.13,0h0a1.07,1.07,0,0,0-2.13,0h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13,10.69a1.06,1.06,0,0,0,2.12,0h0v0h0a1.06,1.06,0,0,0-2.12,0h0v0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13,17.62a1.06,1.06,0,0,0,2.12,0h0a1.06,1.06,0,1,0-2.12,0h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13,14.16a1.06,1.06,0,1,0,2.12,0h0a1.06,1.06,0,1,0-2.12,0h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.82,19.25a.9.9,0,0,1-.9.89H8.07a.89.89,0,0,1-.89-.89V8.58H5.05V19.25a3,3,0,0,0,3,3h7.85a3,3,0,0,0,3-3V8.58H16.82Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20,5.43H4A1,1,0,0,0,3,6.5,1,1,0,0,0,4,7.56H20A1,1,0,0,0,21,6.5,1,1,0,0,0,20,5.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6,4.41h2.79a1.07,1.07,0,1,0,0-2.13H10.6a1.07,1.07,0,0,0,0,2.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.68169b040f3abe18b32bf08354c83852.svg";
export { ForwardRef as ReactComponent };